<footer class="ftr" [class.pb-80]="reserveBottomSpace" [ngStyle]="footerTheme" [style.font-family]="settingsData?.font_family || null">
    <div class="ftr-accent"></div>
    <app-ic-footer-schools *ngIf="groups.length" [groups]="groups" [label]="groupsLabel" [background]="footerTheme['--ftr-bg']"
        (selectGroup)="goToGroup($event)"></app-ic-footer-schools>
    <div class="ftr-inner">
        <div class="ftr-main">
            <div class="ftr-brand">
                <a class="ftr-logo pointer" *ngIf="logoUrl; else footerName" [class.ftr-logo--panel]="showLogoPanel"
                    (click)="goToNetworkHome()" [attr.aria-label]="(networkName || 'Network') + ' home'">
                    <img [src]="logoUrl" alt="">
                </a>
                <ng-template #footerName>
                    <a class="ftr-brand-name pointer" *ngIf="networkName" (click)="goToNetworkHome()">{{ networkName }}</a>
                </ng-template>
                <a class="ftr-brand-name pointer" *ngIf="logoUrl && networkName" (click)="goToNetworkHome()">{{ networkName }}</a>
            </div>
            <div class="ftr-block" *ngIf="deviceType == 'browser'">
                <p class="ftr-label">GET THE APP</p>
                <div class="ftr-apps">
                    <a class="ftr-app" [class.ftr-app--disabled]="!performerDetails?.android_app_link"
                        [attr.href]="performerDetails?.android_app_link || null" target="_blank" rel="noopener"
                        [attr.aria-disabled]="performerDetails?.android_app_link ? null : true"
                        [attr.tabindex]="performerDetails?.android_app_link ? null : -1">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M6 3.5v17l13-8.5z"></path></svg>
                        <span class="ftr-app-text"><small>GET IT ON</small>Google Play</span>
                    </a>
                    <a class="ftr-app" [class.ftr-app--disabled]="!performerDetails?.ios_app_link"
                        [attr.href]="performerDetails?.ios_app_link || null" target="_blank" rel="noopener"
                        [attr.aria-disabled]="performerDetails?.ios_app_link ? null : true"
                        [attr.tabindex]="performerDetails?.ios_app_link ? null : -1">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="2.5"></rect><path d="M11 18.5h2"></path></svg>
                        <span class="ftr-app-text"><small>DOWNLOAD ON THE</small>App Store</span>
                    </a>
                </div>
            </div>
            <div class="ftr-links">
                <nav class="ftr-col">
                    <p class="ftr-label">COMPANY</p>
                    <a class="pointer" (click)="navigate.emit('contactus')">Contact Us</a>
                </nav>
                <nav class="ftr-col">
                    <p class="ftr-label">LEGAL</p>
                    <a class="pointer" (click)="navigate.emit('privacypolicy')">Privacy Policy</a>
                    <a class="pointer" (click)="navigate.emit('cookiepolicy')">Cookie Policy</a>
                    <a class="pointer" (click)="navigate.emit('termsandconditions')">Terms of Service</a>
                </nav>
            </div>
        </div>
        <div class="ftr-bottom" *ngIf="performerDetails?.organization_name">
            &copy; {{ copyRightYear }} {{ performerDetails.organization_name }}. All rights reserved.
        </div>
    </div>
</footer>
